if (!customElements.get('page-intro-video')) {
  class PageIntroVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.video.muted = true;
      this.play = this.play.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);

      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.play();
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.toggleGestureListeners(false);
    }

    play() {
      if (!this.video || !this.video.paused) return;

      const attempt = this.video.play();
      if (!attempt) return;

      attempt
        .then(() => this.toggleGestureListeners(false))
        .catch(() => this.toggleGestureListeners(true));
    }

    onVisibilityChange() {
      if (document.visibilityState === 'visible') this.play();
    }

    toggleGestureListeners(enable) {
      const method = enable ? 'addEventListener' : 'removeEventListener';
      ['touchend', 'click', 'keydown'].forEach((type) => {
        document[method](type, this.play, { passive: true });
      });
    }
  }

  customElements.define('page-intro-video', PageIntroVideo);
}
